/**
 * Paramétrage OMP
 */
export interface ParamOmp {
    /* Données */
    actif: boolean;

    periodeAnInterdit?: boolean;

    exerciceChevalInterdit?: boolean;

    dateDebut?: DateDebutOption;

    dateFin?: DateFinOption;
}

/**
 * Enumération représentant la date de début
 */
export enum DateDebutOption {
    AUCUNE,
    DATE_JOUR,
    DATE_DEBUT_ANNEE,
    DATE_DEBUT_EXERCICE
}

/**
 * Enumération représentant la date de fin
 */
export enum DateFinOption {
    AUCUNE,
    DATE_JOUR,
    DATE_FIN_ANNEE,
    DATE_FIN_EXERCICE
}